import CityPageTemplate from "../city-template/CityPageTemplate";
import { mitchellConfig } from "./data";

export default function MitchellPage() {
  return <CityPageTemplate config={mitchellConfig} />;
}